import type { InsightDto } from "../../types/weekly-cost-report.types";
import { INSIGHT_ICON_MAP } from "@/features/cost/constants/weekly-cost.constants";

export { INSIGHT_ICON_MAP };

/**
 * Get the CSS icon class name for a given insight icon key.
 * Falls back to the 'subscription' icon if the key is not found.
 * @param {InsightDto['iconKey']} iconKey
 * @returns {string} CSS class name for the icon
 */
export const getInsightIcon = (iconKey: InsightDto["iconKey"]): string => {
  return INSIGHT_ICON_MAP[iconKey] || INSIGHT_ICON_MAP.subscription;
};
